import axios, { AxiosInstance } from "axios";
import * as Config from "./Config";

const Api = (accessToken?: string): AxiosInstance => {
  const api = axios.create({
    baseURL: Config.API_URL + "/api/",
  });
  if (accessToken) api.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
  return api;
};

export default Api;
